@use "styles/abstracts/mixins/common" as c;
@use "styles/abstracts/mixins/typography" as t;
@use "styles/abstracts/variables" as v;

.vessel-list {
  flex-grow: 1;

  @include c.custom-scrollbar();

  &.not-available {
    color: v.$palette-gray-900;
    text-align: center;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }

  .row {
    display: flex;

    & + .row {
      margin-top: 16px;
    }
  }

  .vessel {
    padding: 20px 0;

    &:first-child {
      padding-top: 0;
    }

    &:last-child {
      padding-bottom: 0;
    }

    &:not(:last-child) {
      border-bottom: 1px solid v.$palette-gray-200;
    }
  }

  .title {
    @include t.text(14px, 25px, 600);
    width: 120px;
  }

  .value {
    @include t.text(14px, 25px, 400);
  }
}

.not-available-bold {
  @include t.text(16px, 20px, 600);
}

.not-available-normal {
  @include t.text(14px, 22px, 400);
}
